import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { LucideIcon } from 'lucide-react';

interface SummaryCardProps {
  title: string;
  value: string | number;
  icon?: LucideIcon;
  color?: string;
  subtitle?: string;
  loading?: boolean;
}

export const SummaryCard: React.FC<SummaryCardProps> = ({
  title,
  value,
  icon: Icon,
  color = 'text-blue-600 dark:text-blue-400',
  subtitle,
  loading = false,
}) => {
  return (
    <Card className="hover:shadow-md transition-shadow">
      <CardContent className="p-4">
        <div className="text-center">
          <div className="flex items-center justify-center mb-2">
            {Icon && <Icon className={`h-4 w-4 ${color} mr-2`} />}
            <p className="text-xs font-medium text-gray-600 dark:text-gray-400">
              {title}
            </p>
          </div>
          {loading ? (
            <div className="flex items-center justify-center">
              <div className="animate-pulse h-6 w-16 bg-gray-200 dark:bg-gray-700 rounded"></div>
            </div>
          ) : (
            <p className="text-xl font-bold text-gray-900 dark:text-white">
              {value}
            </p>
          )}
          {subtitle && (
            <p className="text-xs text-gray-500 dark:text-gray-500 mt-1">
              {subtitle}
            </p>
          )}
        </div>
      </CardContent>
    </Card>
  );
};